// extracted by mini-css-extract-plugin
export default {"button":"style_button__K80I7","submit":"style_submit__lZ6LL","reset":"style_reset__j25oX"};